module.exports = __webpack_public_path__ + "static/media/icon_plus.adcbf943.svg";